var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#0E46C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3603 32.9757L40.0508 40.0304L33.7731 43.2928C32.646 41.1271 32.6737 38.4407 34.0826 36.2381C35.4915 34.0355 37.9213 32.8743 40.3603 32.9803V32.9757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9932 43.8394C44.5852 46.042 42.1523 47.2032 39.7148 47.0972L40.0241 40.0425L46.3025 36.7847C47.4289 38.9504 47.4012 41.6368 45.9932 43.844V43.8394Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8015 50.0674C26.3182 50.0674 25.867 49.8463 25.577 49.4595C25.2823 49.0726 25.1856 48.5845 25.3145 48.1193L27.9571 38.4755H22.58L19.4633 49.8371C19.4218 49.9891 19.3896 50.1319 19.3712 50.27V50.2931C19.2929 50.7398 19.2929 51.1957 19.3712 51.6517C19.408 51.8912 19.4633 52.1214 19.5415 52.3471C20.0986 53.982 21.7237 55.0781 23.579 55.0781H38.9368V50.0674H26.8061H26.8015ZM60.7307 28.5784C60.7123 28.4587 60.6938 28.3482 60.6754 28.2468C60.2887 26.3632 58.5393 25 56.5045 25H41.1696V30.0015H53.2773C53.7653 30.0015 54.2119 30.2226 54.5065 30.6094C54.8011 30.9963 54.8978 31.4845 54.7643 31.9496L52.1218 41.6026H57.4943L60.611 30.2318C60.6616 30.0337 60.7031 29.8357 60.7307 29.6469C60.7767 29.2877 60.7767 28.9284 60.7307 28.5784Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPicture);
export default __webpack_public_path__ + "static/media/logo-picture.ff7f21c53d0efabade3026366a6620af.svg";
export { ForwardRef as ReactComponent };